<div ng-controller="notificationFooterController as ctrl" class="modal-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>